<template>
  <section id="hero" class="page">
    <!-- TODO: Check the transition mode! -->
    <transition-group name="linear-wipe" mode="out-in">
      <div class="anim-holder" v-for="(word, i) in words" v-show="selected == i" :key="i">
        <h3>{{ word }} </h3>
      </div>
    </transition-group>
    <div class="subtitle">
      <span v-if="separator">...</span>
      <h2>{{ subtitle }}</h2>
      <a v-if="button" :href="button.link" class="button">{{button.text}}</a>
    </div>
    <div class="shapes">
      <div class="diamond" v-for="x in 7"></div>
      <div class="circle" v-for="x in 7"></div>
    </div>
  </section>
</template>

<script>
  export default {
    props: {
      id: String,
      name: String,
      words: Array,
      subtitle: String,
      separator: {
        type: Boolean,
        default: true
      },
      button: {
        type: Object,
        default: null
      }
    },

    data () {
      return {
        selected: 0
      }
    },

    mounted: function () {
      setInterval(() => {
        this.selected = (this.selected + 1) % this.words.length;
      }, 3000);
    }
  }
</script>

<style lang="scss">
  // TODO: move this to the index
  @import "../../css/hero.scss";
  @import "../../css/shapes.scss";
</style>


// WEBPACK FOOTER //
// hero.vue?01b2cffc